import { render, staticRenderFns } from "./modalConfigProduct.vue?vue&type=template&id=2f275b0c"
import script from "./modalConfigProduct.vue?vue&type=script&lang=js"
export * from "./modalConfigProduct.vue?vue&type=script&lang=js"
import style0 from "./modalConfigProduct.vue?vue&type=style&index=0&id=2f275b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports